import { render, staticRenderFns } from "./SynonymList.vue?vue&type=template&id=2f89bccb&"
import script from "./SynonymList.vue?vue&type=script&lang=js&"
export * from "./SynonymList.vue?vue&type=script&lang=js&"
import style0 from "./SynonymList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports